export const WheelAlignmentInfoLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    EXPAND: 'EXPAND',
};
